<template>
  <el-table
    :data="priceTypes"
    max-height="250"
    style="width: 100%"
    v-loading="loading"
    :default-sort="{prop: 'name', order: 'ascending'}"
  >
    <el-table-column
      prop="name"
      label="Név"
    />
    <el-table-column
      fixed="right"
      label=""
      width="120"
    >
      <template slot-scope="scope">
        <Actions :priceType="scope.row" />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import Actions from './Actions'

  export default {

    components: {
      Actions
    },

    computed: {
      priceTypes() {
        return this.$store.getters['priceType/priceTypes'];
      },

      loading() {
        return this.$store.getters['priceType/loading'];
      }
    },

    async mounted() {
      await this.$store.dispatch('priceType/fetchAll');
    },
  }
</script>
